"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var controller_1 = require("./controller");
var schema_1 = require("./schema");
var config_1 = require("./config");
var CodeBlockPlugin = /** @class */ (function (_super) {
    __extends(CodeBlockPlugin, _super);
    function CodeBlockPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = config_1.PLUGIN_NAME;
        _this.Controller = controller_1.CodeBlockController;
        _this.Schema = schema_1.CodeBlock;
        return _this;
    }
    return CodeBlockPlugin;
}(core_utilities_1.SylPlugin));
exports.CodeBlockPlugin = CodeBlockPlugin;
//# sourceMappingURL=index.js.map